import type { RouteLocationNormalized } from 'vue-router';
import { pauseReplay, resumeReplay } from './sessionReplay';
import { sessionReplayConfig } from './config';

/**
 * Pause recording on sensitive routes, resume elsewhere.
 * Registered as a router.beforeEach guard (see src/core/router/index.ts).
 */
export const replayRouteGuard = (to: RouteLocationNormalized): void => {
  const sensitiveNames: readonly string[] = sessionReplayConfig.sensitiveRouteNames;
  const isSensitive = sensitiveNames.includes(String(to.name));
  if (isSensitive) {
    void pauseReplay();
  } else {
    void resumeReplay();
  }
};
